/**
 * PazienteApp — router del portale paziente.
 *
 * Rotte:
 *  - /onboarding/:token              -> OnboardingPage (form principale)
 *  - /onboarding/success             -> OnboardingSuccessPage
 *  - /onboarding/consensi-rifiutati  -> OnboardingConsensiRifiutatiPage
 *  - /onboarding/expired             -> OnboardingExpiredPage
 *  - *                               -> OnboardingNotFoundPage (404)
 *
 * NO Firebase Auth init, NO link a gestionale.
 */

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { OnboardingPage } from './pages/OnboardingPage';
import { OnboardingSuccessPage } from './pages/OnboardingSuccessPage';
import { OnboardingConsensiRifiutatiPage } from './pages/OnboardingConsensiRifiutatiPage';
import { OnboardingExpiredPage } from './pages/OnboardingExpiredPage';
import { OnboardingNotFoundPage } from './pages/OnboardingNotFoundPage';

export function PazienteApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/onboarding/success" element={<OnboardingSuccessPage />} />
        <Route
          path="/onboarding/consensi-rifiutati"
          element={<OnboardingConsensiRifiutatiPage />}
        />
        <Route path="/onboarding/expired" element={<OnboardingExpiredPage />} />
        <Route path="/onboarding/:token" element={<OnboardingPage />} />
        <Route path="*" element={<OnboardingNotFoundPage />} />
      </Routes>
      <Toaster richColors position="top-center" closeButton />
    </BrowserRouter>
  );
}
